import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "42",
  height: "42"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M20.999 31.457q.657 0 1.082-.423.424-.423.424-1.08 0-.659-.424-1.082-.421-.424-1.08-.424-.657 0-1.082.423-.424.423-.424 1.08 0 .659.424 1.083.421.423 1.08.423m-1.13-7.796h2.508V9.87H19.87v13.79zM21.02 42q-4.364 0-8.174-1.653t-6.673-4.516-4.518-6.675T0 20.976q0-4.347 1.653-8.172t4.516-6.66 6.675-4.49T21.024 0q4.347 0 8.172 1.653 3.825 1.655 6.66 4.488 2.835 2.835 4.49 6.667Q42 16.64 42 20.982q0 4.363-1.653 8.173t-4.488 6.663-6.667 4.517T21.018 42z"
    }, null, -1)
  ])))
}
export default { render: render }